import { Directive, TemplateRef, inject } from '@angular/core';

/**
 * Projectable template for rendering an event popover content.
 * Usage:
 * <ng-template beautyappSchedulerEventPopover let-event let-resource="resource" let-viewMode="viewMode">
 *   <div class="popover-custom">
 *     <div class="title">{{ event.title || 'Event' }}</div>
 *     <div class="line">{{ event.start | date:'shortTime' }} - {{ event.end | date:'shortTime' }}</div>
 *     <div class="line">{{ resource?.title }}</div>
 *   </div>
 * </ng-template>
 */
@Directive({
  selector: 'ng-template[beautyappSchedulerEventPopover]',
  standalone: true
})
export class BeautySchedulerEventPopoverTemplateDirective {
  readonly template = inject<TemplateRef<any>>(TemplateRef);
}
